"use strict";

var React = require('react');

function ModalHeader(props) {
  return React.createElement(
    "header",
    { className: "cf-modal__header" },
    props.children
  );
}

module.exports = ModalHeader;